import { render, staticRenderFns } from "./powerManager.vue?vue&type=template&id=1a867af8&scoped=true&"
import script from "./powerManager.vue?vue&type=script&lang=js&"
export * from "./powerManager.vue?vue&type=script&lang=js&"
import style1 from "./powerManager.vue?vue&type=style&index=1&id=1a867af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a867af8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a867af8')) {
      api.createRecord('1a867af8', component.options)
    } else {
      api.reload('1a867af8', component.options)
    }
    module.hot.accept("./powerManager.vue?vue&type=template&id=1a867af8&scoped=true&", function () {
      api.rerender('1a867af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/powerManager.vue"
export default component.exports